import { useEffect } from "react";

/**
 * ======================================================
 * HOOK - FERMETURE VIA ESCAPE
 * ======================================================
 *
 * Role :
 * - standardiser la fermeture clavier des overlays de l application
 * - eviter de dupliquer la meme logique entre profil, event et futures UI
 * - fournir un comportement accessible et stable
 */

export function useEscapeToClose({ enabled = true, onClose } = {}) {
  useEffect(() => {
    if (!enabled || typeof onClose !== "function") {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [enabled, onClose]);
}
